/**
 * Shared constants for the polished panel resize handle.
 *
 * The handle itself is always exactly 40px (hit target, WCAG) regardless of the
 * visible pill size. Keep these tuned together; they're referenced by both the
 * primitive and its tests.
 */

/** Step size for keyboard arrow resize. Shift multiplies this. */
export const KEYBOARD_STEP = 16;

/** Larger step when Shift is held. */
export const KEYBOARD_STEP_LARGE = 64;

/** Movement threshold (px) below which a pointer interaction is treated as a click. */
export const CLICK_THRESHOLD_PX = 4;

/**
 * Delay (ms) before the hover tooltip pill fades in. Matches the
 * Linear/Notion feel — slow enough to avoid accidental reveals,
 * fast enough to feel responsive to intent.
 */
export const TOOLTIP_HOVER_DELAY_MS = 400;

/**
 * localStorage key prefix. Versioned per the `client-localstorage-schema`
 * convention so we can evolve the stored shape without breaking older clients.
 */
export const STORAGE_KEY_PREFIX = 'otto:panel-width:v1:';

/** Clamp a number between min and max. */
export const clamp = (v: number, min: number, max: number): number =>
  Math.max(min, Math.min(max, v));
